import { createContext, useContext, type ReactNode } from "react";
import type { WidgetRegistry } from "./registry";

const RegistryContext = createContext<WidgetRegistry | null>(null);

/**
 * Provides the widget registry instance to the harness, grid, and catalog. The kit
 * carries no process-global — a consumer creates a registry with
 * `createWidgetRegistry()`, registers its modules, and mounts it here.
 */
export function WidgetRegistryProvider({
  registry,
  children,
}: {
  registry: WidgetRegistry;
  children: ReactNode;
}) {
  return <RegistryContext.Provider value={registry}>{children}</RegistryContext.Provider>;
}

export function useWidgetRegistry(): WidgetRegistry {
  const registry = useContext(RegistryContext);
  if (!registry) {
    throw new Error("useWidgetRegistry must be used within a <WidgetRegistryProvider>.");
  }
  return registry;
}
